import React from 'react'
import Resume from '../../assets/Michael_Fang_Resume.pdf'

const CTA = () => {
  return (
    <div className='cta'>
        <a href= {Resume} download className='btn'>Download Resume</a>
        <a href="#contact" className='btn btn-primary'>Get in touch</a>
    </div>
  )
}

export default CTA
